import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getLaunchRemaining } from "@/lib/launch";
import { useI18n } from "@/i18n/I18nContext";

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="relative overflow-hidden h-[64px] md:h-[88px] w-full">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.div
          key={value}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
          className="font-display text-[3.5rem] md:text-[5rem] leading-none tracking-[-0.04em] text-center"
        >
          {String(value).padStart(2, "0")}
        </motion.div>
      </AnimatePresence>
    </div>
    <div className="font-mono-caption text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-[var(--cream)]/60 mt-1">
      {label}
    </div>
  </div>
);

export default function Countdown() {
  const { t } = useI18n();
  const [tick, setTick] = useState(() => getLaunchRemaining());

  useEffect(() => {
    const id = setInterval(() => setTick(getLaunchRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  if (tick.ended) {
    return (
      <div
        className="rounded-2xl border border-[rgba(253,251,247,0.15)] bg-[rgba(253,251,247,0.04)] px-4 py-3 text-center text-[12px] text-[var(--cream)]/70"
        data-testid="countdown-ended"
      >
        {t.countdown.ended}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border border-[var(--marigold)]/30 bg-[rgba(230,92,0,0.07)] px-4 py-3 md:px-5 md:py-4"
      data-testid="countdown-live"
    >
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-2 font-mono-caption text-[9.5px] tracking-[0.2em] uppercase text-[var(--marigold-2)]">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--marigold)] opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--marigold)]" />
          </span>
          {t.countdown.label}
        </div>
        <div className="text-[10px] text-[var(--cream)]/50 font-mono-caption">
          {t.countdown.price_hint}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 md:gap-3 text-[var(--cream)]">
        <Unit value={tick.m} label={t.countdown.minutes} />
        <Unit value={tick.s} label={t.countdown.seconds} />
      </div>
    </div>
  );
}
